import type { CatalogosRespuesta } from '@tms/contratos';
import { api } from '../api';
import { useCarga } from './hooks';

const VACIO: CatalogosRespuesta = { empresas: [], unidadesNegocio: [], subunidadesNegocio: [], clientes: [] };

/** Catálogos para los filtros (GET /catalogos). Mientras cargan o si fallan, las listas quedan vacías. */
export function useCatalogos(): CatalogosRespuesta {
  return useCarga(() => api.catalogos(), []).datos ?? VACIO;
}
